import { put, takeLatest, select } from 'redux-saga/effects';

import forEach from 'lodash/forEach';

import { formatError } from '../../../libs';
import { Types, Creators as CategoryCreators } from '../../reducers/category';
import getState from '../../utils/getState';

function* cleanFilteredItems() {
  try {
    const {
      category: { searchQuery },
    } = yield select(getState);

    const filter = {};

    forEach(searchQuery.getIn(['filter']), function cb(item, key) {
      filter[key] = item.filter((subItem) => subItem.fixed === true);
    });

    yield put(
      CategoryCreators.cleanFilteredItemsSuccess({
        searchQuery: searchQuery.merge({ filter }),
        filteredItems: [],
      })
    );
    yield put(CategoryCreators.setSearchQueryRequest());
  } catch (error) {
    yield put(CategoryCreators.cleanFilteredItemsError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CLEAN_FILTERED_ITEMS_REQUEST, cleanFilteredItems);
}
